const whitelistedProfessionalIDs = [
    25375, // voda-plumbingware
];

export default whitelistedProfessionalIDs;
